import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { LoginCallbackComponent } from './login-callback.component';

@NgModule({
  declarations: [LoginCallbackComponent],
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    ToastModule
  ],
  exports: [LoginCallbackComponent]
})
export class LoginCallbackModule { }
